import { DialogLocal } from "@/components/Dialog";
import { Empty } from "@/components/Empty";
import { Icon } from "@/components/Icon";
import SubLayout from "@/components/SubLayout";
import { useEffect } from "react";
import styles from "./index.module.scss";
import { Device, useLogic } from "./logic";
type DeviceItemProps = {
  device: Device;
  onClick?: () => void;
};
const DeviceItemRender = (props: DeviceItemProps) => {
  const {
    device,
    onClick
  } = props;
  const onItemClick = () => {
    !device.isFirst && typeof onClick === "function" && onClick();
  };
  return <div onClick={onItemClick} className={styles.item} data-sentry-component="DeviceItemRender" data-sentry-source-file="index.tsx">
      <div className={styles.device_info}>
        <div className={styles.item_type}>{device.deviceModel}</div>
        <div className={styles.item_active}>
          {device.isFirst ? "当前设备" : ""}
        </div>
        <div className={styles.item_no}>{device.lastLoginTime}</div>
        <div className={styles.item_no}>{device.operatingSystem}</div>
      </div>

      <div className={styles.item_icon}>
        <Icon name={"trash"} size={"20px"} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
export function PageDevices() {
  const store = useLogic();
  const onItemClick = (item: Device) => {
    DialogLocal({
      content: "您确认要删除该设备吗？",
      cancelText: "取消",
      onConfirm: async () => {
        store.fetchDeleteDevice(item.uuid);
        return true;
      }
    });
  };
  useEffect(() => {
    store.fetchList();
  }, []);
  return <SubLayout title={"设备管理"} data-sentry-element="SubLayout" data-sentry-component="PageDevices" data-sentry-source-file="index.tsx">
      <div className={styles.wrapper}>
        <section className={styles.header}>
          您的账号在以下设备中登录过，VipPay会视为安全使用，无需进行安全验证，您可以删除设备，删除后重新在该设备登录时，需时行安全验证。
        </section>
        <section className={styles.content}>
          <div className={styles.tip}>已登录的设备</div>
          {Array.isArray(store.list) && store.list.length ? store.list.map(item => {
          return <DeviceItemRender device={item} onClick={() => {
            onItemClick(item);
          }} key={item.uuid} />;
        }) : <Empty />}
        </section>
      </div>
    </SubLayout>;
}